"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const openapi_1 = require("../../../../openapi");
const guard_1 = require("../guard");
const shared_1 = require("../shared");
const OtaBuild = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Device.OtaBuild.Spec';
const BuildResponse = openapi_1.Response.Success(OtaBuild.OtaBuild).annotations({
    description: 'An OTA build artifact',
});
const BuildListResponse = openapi_1.Response.Success(OtaBuild.OtaBuildList).annotations({
    description: 'OTA build artifacts matching the search',
});
const BuildUrlResponse = openapi_1.Response.Success(OtaBuild.OtaBuildUrl).annotations({
    description: 'A signed URL for the build artifact file',
});
const UniqueResultResponse = openapi_1.Response.Success(OtaBuild.OtaBuildUniqueResult).annotations({
    description: 'Whether the id is free to use',
});
const CreatedResponse = openapi_1.Response.EmptyData.annotations({
    description: 'The build artifact is now available for distribution',
});
// Query structs intentionally have no identifier (see shared.ts).
const SearchQuery = effect_1.Schema.Struct({
    model: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Device model code',
    }),
    buildFile: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    userId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Publisher user ID',
    }),
    enabled: effect_1.Schema.optionalWith(effect_1.Schema.Literal('true', 'false', '1', '0'), { exact: true }).annotations({
        description: 'sanitizeObject coerces true/"true"/1/"1" to true, everything else to false.',
    }),
    version: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    id: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Not validated, but supported: filters by build id (== buildFile).',
    }),
    minVersion: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Not validated, but supported.',
    }),
});
const DownloadUrlQuery = effect_1.Schema.Struct({
    buildFile: effect_1.Schema.NonEmptyString,
});
const UploadUrlQuery = effect_1.Schema.Struct({
    model: effect_1.Schema.NonEmptyString,
    buildFile: effect_1.Schema.NonEmptyString,
    version: effect_1.Schema.NonEmptyString,
});
const UniqueQuery = effect_1.Schema.Struct({
    id: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }),
});
const EmptyBody = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.EmptyBody`, 'INVALID_REQUEST', 'Empty Body', 'The patch body has no fields other than id. Carries no express-validator field errors.', { inputValidation: effect_1.Schema.Literal('Body cannot be empty!') });
const searchOtaBuilds = platform_1.HttpApiEndpoint.get('searchOtaBuilds') `/ota/builds/search`
    .setUrlParams(SearchQuery)
    .addSuccess(BuildListResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Search OTA Builds')
    .annotate(platform_1.OpenApi.Description, 'Searches OTA build artifacts by exact match on model, buildFile, userId, enabled and version. id and minVersion also filter but are not validated. No pagination.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const listOtaBuilds = platform_1.HttpApiEndpoint.get('listOtaBuilds') `/ota/builds/list`
    .setUrlParams(SearchQuery)
    .addSuccess(BuildListResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'List OTA Builds')
    .annotate(platform_1.OpenApi.Description, 'Alias of GET /ota/builds/search.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const getOtaBuildDownloadUrl = platform_1.HttpApiEndpoint.get('getOtaBuildDownloadUrl') `/ota/builds/url`
    .setUrlParams(DownloadUrlQuery)
    .addSuccess(BuildUrlResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Get OTA Build Download URL')
    .annotate(platform_1.OpenApi.Description, 'Returns a signed download URL valid for 24 hours. Answers 500 (not 404) when the build does not exist or is disabled.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const getOtaBuildUploadUrl = platform_1.HttpApiEndpoint.get('getOtaBuildUploadUrl') `/ota/builds/upload-url`
    .setUrlParams(UploadUrlQuery)
    .addSuccess(BuildUrlResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1Conflict)
    .annotate(platform_1.OpenApi.Title, 'Get OTA Build Upload URL')
    .annotate(platform_1.OpenApi.Description, 'Returns a signed URL for an HTTP PUT upload, valid for 1 hour. buildFile must be unique: 409 when a build with that file already exists.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const getOtaBuild = platform_1.HttpApiEndpoint.get('getOtaBuild') `/ota/build`
    .setUrlParams(shared_1.IdQuery)
    .addSuccess(BuildResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Get OTA Build')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const checkOtaBuildUnique = platform_1.HttpApiEndpoint.get('checkOtaBuildUnique') `/ota/build/unique`
    .setUrlParams(UniqueQuery)
    .addSuccess(UniqueResultResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Check OTA Build Id Is Unique')
    .annotate(platform_1.OpenApi.Description, 'Guarded by the write role despite being a GET.')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const publishOtaBuild = platform_1.HttpApiEndpoint.post('publishOtaBuild') `/ota/build`
    .setPayload(OtaBuild.PublishOtaBuildPayload)
    .addSuccess(CreatedResponse, { status: 201 })
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Publish OTA Build')
    .annotate(platform_1.OpenApi.Description, 'Makes a previously uploaded file available for distribution. 404 when the blob has not been uploaded yet. Silently overwrites and re-enables an existing build with the same buildFile.')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const createOtaBuild = platform_1.HttpApiEndpoint.post('createOtaBuild') `/ota/build/create`
    .setPayload(OtaBuild.CreateOtaBuildPayload)
    .addSuccess(CreatedResponse, { status: 201 })
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Create OTA Build')
    .annotate(platform_1.OpenApi.Description, 'id is used as the buildFile and must be unique (422, not 409, when already taken). 404 when the blob has not been uploaded yet.')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const replaceOtaBuild = platform_1.HttpApiEndpoint.put('replaceOtaBuild') `/ota/build/put`
    .setUrlParams(shared_1.IdQuery)
    .setPayload(OtaBuild.ReplaceOtaBuildPayload)
    .addSuccess(BuildResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Replace OTA Build')
    .annotate(platform_1.OpenApi.Description, 'id is taken from the query string. If the body also carries an id it silently overrides the query one.')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const patchOtaBuild = platform_1.HttpApiEndpoint.patch('patchOtaBuild') `/ota/build/patch`
    .setUrlParams(shared_1.IdQuery)
    .setPayload(OtaBuild.PatchOtaBuildPayload)
    .addSuccess(BuildResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(EmptyBody)
    .annotate(platform_1.OpenApi.Title, 'Patch OTA Build')
    .annotate(platform_1.OpenApi.Description, 'id is taken from the query string (body id silently overrides it). An empty body answers 422 with a plain-string inputValidation message ("Body cannot be empty!").')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const deleteOtaBuild = platform_1.HttpApiEndpoint.del('deleteOtaBuild') `/ota/build`
    .setUrlParams(effect_1.Schema.Struct({ id: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }) }))
    .setPayload(OtaBuild.DeleteOtaBuildPayload)
    .addSuccess(openapi_1.Response.EmptyData)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Delete OTA Build')
    .annotate(platform_1.OpenApi.Description, 'id may be supplied via query or body (at least one is required); the body id wins when both are present. Also deletes the underlying blob. An unknown id currently answers 500 (not 404).')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.admin.device.ota-build')
    .add(searchOtaBuilds)
    .add(listOtaBuilds)
    .add(getOtaBuildDownloadUrl)
    .add(getOtaBuildUploadUrl)
    .add(getOtaBuild)
    .add(checkOtaBuildUnique)
    .add(publishOtaBuild)
    .add(createOtaBuild)
    .add(replaceOtaBuild)
    .add(patchOtaBuild)
    .add(deleteOtaBuild)
    .prefix('/admin/device')
    .annotate(platform_1.OpenApi.Title, 'Device OTA Builds')
    .annotate(platform_1.OpenApi.Description, 'Admin OTA firmware build artifact endpoints')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
//# sourceMappingURL=spec.js.map